import * as envs from './environments'

function getCurrentEnvironment() {
  const configKey = `${process.env.VUE_APP_MODE.toUpperCase()}_ENVIRONMENT`
  return envs[configKey] || envs.QA_ENVIRONMENT
}

export default getCurrentEnvironment()
